// @ts-nocheck - TODO: properly type this file!

// Work is in progress on this file
import NotificationFilterApplySelector from './NotificationFilterApplySelector';
import { NotificationApplyOptions } from '../../../../common/static_data';
import { useState } from 'react';
import { Flex, Form } from 'antd';
import { DeleteIcon } from '@/assets/icons/icons';
import { CustomShipmentText } from '@/components';
import { useTeamGroups } from '@/hooks/useTeamGroups';

const NotificationFilterApply = ({
  form,
  setApplyType,
  applyType,
  allApplyType,
  applyConfig,
}) => {
  const [open, setOpen] = useState(false);
  const [openState, setOpenState] = useState<Record<number, boolean>>({});
  // Team groups expand to their teams in the team filter.
  const teamCfg = Object.values(applyConfig ?? {}).find(
    (cfg) => cfg?.key === 'filter_teams'
  );
  const teamGroups = useTeamGroups(
    (teamCfg?.list ?? []).map((item) => item.id),
    !!teamCfg
  );

  // If the parent "Select All" was clicked, mark every included category as All too.
  const handleApplyTypes = (val, isAllSelected = false) => {
    setApplyType(val);
    setOpen(false);
    Object.entries(applyConfig).forEach(([type, cfg]) => {
      const isIncluded = val.includes(Number(type));
      if (!isIncluded) {
        form.setFieldsValue({ [cfg.key]: [], [cfg.stateKey]: isAllSelected });
      } else if (isAllSelected) {
        form.setFieldsValue({ [cfg.key]: [], [cfg.stateKey]: true });
      }
    });
  };

  // Store selected values(ids) and explicitly track whether "All" was selected.
  const handleApplyFilters = (val, cfg, isAllSelected) => {
    form.setFieldsValue({
      [cfg.key]: isAllSelected ? [] : val,
      [cfg.stateKey]: !!isAllSelected,
    });
  };

  // Collapse to "All" only when every active category was explicitly marked All.
  const allCategoriesExplicitAll =
    applyType.length === NotificationApplyOptions.length &&
    applyType.every((type) => form.getFieldValue(applyConfig[type]?.stateKey));

  return (
    <>
      <Flex vertical gap={16}>
        <div>
          <CustomShipmentText
            text={'Which shipments does this apply to'}
            fontSize='14px'
            marginBottom='4px'
            fontWeight={600}
          />
          <NotificationFilterApplySelector
            applyType={applyType}
            isParernt={true}
            setOpen={setOpen}
            open={open}
            list={NotificationApplyOptions}
            titleText=''
            border='1px solid var(--filter-tag-border)'
            background='var(--surface-container)'
            color='var(--filter-tag-text)'
            handleApplyFilters={handleApplyTypes}
            patchedIsAll={allCategoriesExplicitAll}
          />
        </div>
        {!allCategoriesExplicitAll && (
          <>
            {applyType?.map((type) => {
              const cfg = applyConfig[type];
              if (!cfg) return null;
              return (
                <Form.Item
                  key={type}
                  className='custom-input form-input-style custom-select-disabled-only'
                  label={cfg.label}
                  name={cfg.key}
                  //preserve={false}
                  getValueFromEvent={(val) => val}
                  style={{ flex: 1 }}
                  // hidden={applyType?.length === 5}
                >
                  <Flex key={type} align='center' gap={16}>
                    <NotificationFilterApplySelector
                      formName={cfg.key}
                      form={form}
                      patchedArray={form.getFieldValue(cfg.key) ?? []}
                      patchedIsAll={form.getFieldValue(cfg.stateKey) ?? false}
                      isParernt={false}
                      open={openState[type] || false}
                      setOpen={(val: boolean) =>
                        setOpenState((prev) => ({ ...prev, [type]: val }))
                      }
                      list={cfg.list}
                      titleText={cfg.label}
                      border='0px'
                      background='rgba(94, 94, 94, 1)'
                      color='white'
                      handleApplyFilters={(val, isAllSelected) => {
                        handleApplyFilters(val, cfg, isAllSelected);
                        setOpenState((prev) => ({ ...prev, [type]: false }));
                      }}
                      applyCourierId={cfg.applyCourierId}
                      allApplyType={allApplyType}
                      teamGroups={
                        cfg.key === 'filter_teams' ? teamGroups : undefined
                      }
                    />
                    <div>
                      <DeleteIcon
                        color='var(--text-secondary)'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setApplyType((prev) =>
                            prev.filter((val) => val !== type)
                          );
                          form.setFieldsValue({
                            [cfg.key]: [],
                            [cfg.stateKey]: false,
                          });
                        }}
                      />
                    </div>
                  </Flex>
                </Form.Item>
              );
            })}
          </>
        )}
      </Flex>
    </>
  );
};

export default NotificationFilterApply;
